module.exports = __webpack_public_path__ + "static/img/256_TO8_2316_og.2237f2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/256_TO8_2316_og.jpg
// module id = oqCN
// module chunks = 0